import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

export const WorkWeeksSkeleton = () => (
  <Box
    data-testid="work-weeks-skeleton"
    display="flex"
    flexDirection="column"
    alignItems="center"
    sx={{ mt: 10 }}
  >
    <Skeleton sx={{ mb: 2 }} height={25} width={80} />
    <Skeleton sx={{ mb: 4 }} height={400} width="100%" />
  </Box>
);
